let activeAccount = null;

export const setMsalAccount = (account) => {
  activeAccount = account;
};

export const getMsalAccount = () => activeAccount;
